/**
 * Other spellings of our city slugs that people type or link to: the local
 * name in another language ("Fès", "Tanger", "Marrakesch") or a common
 * transliteration ("Marrakesh"). Each one 301s to the canonical slug instead
 * of answering 404, so a guest on /es/place/fes or /ar/place/tanger lands on
 * the city hub and a search engine moves the signal onto the real URL.
 *
 * Keys are lowercase with accents removed; see `canonicalCitySlug`.
 */
const CITY_SLUG_ALIASES: Readonly<Record<string, string>> = {
  fes: "fez",
  tanger: "tangier",
  tangeri: "tangier",
  tanja: "tangier",
  marrakesh: "marrakech",
  marrakesch: "marrakech",
  marrakech: "marrakech",
  tetuan: "tetouan",
  tetouan: "tetouan",
  mequinez: "meknes",
  meknes: "meknes",
  uarzazate: "ouarzazate",
  esauira: "essaouira",
  dajla: "dakhla",
  chaouen: "chefchaouen",
  xauen: "chefchaouen",
};

function fold(slug: string): string {
  let decoded = slug;
  try {
    decoded = decodeURIComponent(slug);
  } catch {
    // A stray % is not an alias; compare the raw text.
  }
  return decoded.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

/**
 * The canonical slug when `slug` is a known alias that differs from it,
 * otherwise `null` (already canonical, or unknown: let the 404 guard decide).
 */
export function canonicalCitySlug(slug: string | undefined | null): string | null {
  if (!slug) return null;
  const target = CITY_SLUG_ALIASES[fold(slug)];
  return target && target !== slug ? target : null;
}
